import { Fragment, useEffect, useState } from "react";

import {
	Button,
	Card,
	Col,
	DatePicker,
	Form,
	Input,
	InputNumber,
	Row,
	Select,
	Timeline,
	TimePicker,
	Typography
} from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addManualAttendance, loadAllAttendance } from "../../redux/rtk/features/attendance/attendanceSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import GetAllAttendance from "./GetAllAttendance";



const Attendance = ({ drawer }) => {
	const [loader, setLoader] = useState(false);
	const users = useSelector((state) => state.users?.list);
	const dispatch = useDispatch();
	const { Title } = Typography;
	const [form] = Form.useForm();
	const [durations, setDurations] = useState({
		totalDuration: "",
		breakDuration: "",
		workedDuration: "",
	});

	const [errors, setErrors] = useState({
		inTime: null,
		// breakHourStart: null,
		// breakHourEnd: null,
		outTime: null,
	});

	const [timeFields, setTimeFields] = useState({
		inTime: { time: null, date: null },
		// breakStart: { time: null, date: null },
		// breakEnd: { time: null, date: null },
		outTime: { time: null, date: null }
	});

	// Helper function to create Date object from time and date
	const createDateFromTimeDate = (timeDate) => {
		if (!timeDate.date || !timeDate.time) return null;
		return new Date(Date.UTC(
			timeDate.date.split('-')[2],
			timeDate.date.split('-')[1] - 1,
			timeDate.date.split('-')[0],
			...timeDate.time.split(':').map(Number)
		));
	};

	// const createDateFromTimeDate = (timeDate) => {
	// 	if (!timeDate?.date || !timeDate?.time) return null;

	// 	const dateParts = timeDate.date.split('-');
	// 	let year, month, day;

	// 	// Check if the date is in `YYYY-MM-DD` or `DD-MM-YYYY` format
	// 	if (dateParts[0].length === 4) {
	// 		// Format: YYYY-MM-DD
	// 		[year, month, day] = dateParts;
	// 	} else {
	// 		// Format: DD-MM-YYYY
	// 		[day, month, year] = dateParts;
	// 	}

	// 	// Convert to numbers
	// 	year = Number(year);
	// 	month = Number(month) - 1; // Months are 0-based in JS
	// 	day = Number(day);

	// 	// Extract time
	// 	const timeParts = timeDate.time.split(':').map(Number);

	// 	// return new Date(Date.UTC(year, month, day, ...timeParts));
	// 	return new Date(year, month, day, ...timeParts);
	// };


	// Create Date objects for all fields

	const dates = {
		inTime: createDateFromTimeDate(timeFields.inTime),
		// breakStart: createDateFromTimeDate(timeFields.breakStart),
		// breakEnd: createDateFromTimeDate(timeFields.breakEnd),
		outTime: createDateFromTimeDate(timeFields.outTime)
	};

	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, []);


	// useEffect(() => {
	// 	if (dates.inTime && dates.outTime && dates.breakStart && dates.breakEnd) {
	// 	  const totalDuration = dates.outTime - dates.inTime;
	// 	  const breakDuration = dates.breakEnd - dates.breakStart;
	// 	  const workedDuration = totalDuration - breakDuration;

	// 	  const formatDuration = (duration) => {
	// 		const totalMinutes = Math.floor(duration / (1000 * 60));
	// 		const hours = Math.floor(totalMinutes / 60);
	// 		const minutes = totalMinutes % 60;
	// 		return `${hours} hours ${minutes} minutes`;
	// 	  };

	// 	  setDurations({
	// 		totalDuration: formatDuration(totalDuration),
	// 		breakDuration: formatDuration(breakDuration),
	// 		workedDuration: formatDuration(workedDuration),
	// 	  });
	// 	}
	//   }, [dates.inTime, dates.outTime, dates.breakStart, dates.breakEnd]);

	useEffect(() => {
		if (dates.inTime && dates.outTime) {
			const totalDuration = dates.outTime - dates.inTime;
			const breakDuration = form.getFieldValue("totalBreakHours") * 60 * 60 * 1000; // Convert break hours to milliseconds
			const workedDuration = totalDuration - breakDuration;

			const formatDuration = (duration) => {
				const totalMinutes = Math.floor(duration / (1000 * 60));
				const hours = Math.floor(totalMinutes / 60);
				const minutes = totalMinutes % 60;
				return `${hours} hours ${minutes} minutes`;
			};

			setDurations({
				totalDuration: formatDuration(totalDuration),
				breakDuration: formatDuration(breakDuration),
				workedDuration: formatDuration(workedDuration),
			});
		}
	}, [dates.inTime, dates.outTime, form.getFieldValue("totalBreakHours")]);

	// useEffect(() => {
	// 	// Only validate if at least one field is filled
	// 	if (Object.values(dates).some(date => date !== null)) {
	// 	  validateDates();
	// 	}
	//   }, [dates.inTime, dates.breakStart, dates.breakEnd, dates.outTime]);
	useEffect(() => {
		// Validate only if relevant fields are filled
		if (dates.inTime && dates.outTime) {
			validateDates();
		}
	}, [dates.inTime, dates.outTime]);

	// const validateDates = () => {
	// 	const newErrors = {
	// 	  inTime: null,
	// 	//   breakHourStart: null,
	// 	//   breakHourEnd: null,
	// 	  outTime: null,
	// 	};


	// 	// Only validate break start if both work start and break start are set
	// 	if (dates.inTime && dates.breakStart) {
	// 	  if (dates.breakStart < dates.inTime) {
	// 		console.log("b s error ");

	// 		newErrors.breakHourStart = "Break start must be after work start";
	// 	  }
	// 	}

	// 	// Only validate break end if both break start and break end are set
	// 	if (dates.breakStart && dates.breakEnd) {
	// 	  if (dates.breakEnd < dates.breakStart) {
	// 		newErrors.breakHourEnd = "Break end must be after break start";
	// 	  }
	// 	}

	// 	// Only validate work end if it exists and other relevant fields are set
	// 	if (dates.outTime) {
	// 	  if (dates.inTime && dates.outTime < dates.inTime) {
	// 		newErrors.outTime = "Work end must be after work start";
	// 	  }
	// 	  if (dates.breakStart && dates.breakEnd) {
	// 		if (dates.outTime < dates.breakEnd) {
	// 		  newErrors.outTime = "Work end must be after break end";
	// 		}
	// 	  }
	// 	}

	// 	setErrors(newErrors);
	// 	return !Object.values(newErrors).some(error => error !== null);
	//   };

	const validateDates = () => {
		const newErrors = {
			inTime: null,
			outTime: null,
		};

		if (dates.inTime && dates.outTime && dates.outTime < dates.inTime) {
			newErrors.outTime = "Work end must be after work start";
		}

		setErrors(newErrors);
		return !Object.values(newErrors).some(error => error !== null);
	};

	const handleDateTimeChange = (type, field, value) => {
		setTimeFields(prev => ({
			...prev,
			[type]: {
				...prev[type],
				[field]: value
			}
		}));
	};


	const onFinish = async (values) => {
		if (!validateDates()) {
			Object.values(errors)
				.filter((msg) => msg)
				.forEach((msg) => toast.error(msg));
			setLoader(false);

			return;
		}

		const FormData = {
			...values,
			inTime: dates.inTime,
			//   breakHourStart: dates.breakStart,
			//   breakHourEnd: dates.breakEnd,
			outTime: dates.outTime,
			totalDuration: durations.workedDuration
		};

		setLoader(true);
		const resp = await dispatch(addManualAttendance(FormData));
		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
			dispatch(loadAllAttendance());
		}
		setLoader(false);
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding shift");
		setLoader(false);
	};

	return (
		<Fragment>
			<UserPrivateComponent permission={"create-attendance"}>
				<Row className='mr-top' justify={drawer ? "center" : "space-between"}>
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={drawer ? 22 : 12}
						xl={drawer ? 22 : 12}
						className='column-design border rounded card-custom'>
						<Title level={4} className='m-2 mt-5 mb-5 text-center'>
							Add Manual Attendance
						</Title>
						{!timeFields.inTime.time || !timeFields.inTime.date
							? (
								<p className='text-center text-rose-500 text-sm font-medium mb-4'>
									{" "}
									* Please fill Date and Time
								</p>
							) : (
								""
							)}
						<Form
							form={form}
							style={{ marginBottom: "40px" }}
							eventKey='shift-form'
							name='basic'
							labelCol={{
								span: 6,
							}}
							wrapperCol={{
								span: 12,
							}}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
							<div>
								<Form.Item
									style={{ marginBottom: "10px" }}
									label='User'
									name='userId'
									rules={[
										{
											required: true,
											message: "Please select user!",
										},
									]}>
									<Select placeholder='Select User'
										showSearch allowClear
										filterOption={(input, option) =>
											String(option.children).toLowerCase().includes(input.toLowerCase())
										}>
										{users?.slice() // Create a copy to avoid mutating the original array
											.sort((a, b) => a.firstName.localeCompare(b.firstName)).map((user) => (
												<Select.Option key={user.id} value={user.id}>
													{user.firstName} {user.lastName}
												</Select.Option>
											))}
									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Work Start Time'
									rules={[
										{
											required: true,
											message: "Please input your start time!",
										},
									]}>
									<div className='flex justify-between'>
										<DatePicker
											format={"DD-MM-YYYY"}
											onChange={(date, dateString) =>
												handleDateTimeChange('inTime', 'date', dateString)
											}
											status={errors.inTime ? "error" : ""}
											showToday={false}
											maxDate={dayjs().add(1, 'day')}
										/>
										<TimePicker
											className='ml-4'
											// format={"HH:mm:s"}
											format={"HH:mm"}
											onChange={(time, timeString) =>
												handleDateTimeChange('inTime', 'time', timeString)
											}
											status={errors.inTime ? "error" : ""}
											showNow={false}

										/>
									</div>
									{errors.inTime && <div className="text-red-500 text-sm mt-1">{errors.inTime}</div>}
								</Form.Item>

								{/* <Form.Item
									style={{ marginBottom: "10px" }}
									label='Break Start Time'
									rules={[
										{
											required: true,
											message: "Please input your break start time!",
										},
									]}>
									<div className='flex justify-between'>
										<DatePicker
											format={"DD-MM-YYYY"}
											onChange={(date, dateString) =>
												handleDateTimeChange('breakStart', 'date', dateString)
											}
											status={errors.breakStart ? "error" : ""}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm:s"}
											onChange={(time, timeString) =>
												handleDateTimeChange('breakStart', 'time', timeString)
											}
											status={errors.breakStart ? "error" : ""}
										/>
									</div>
									{errors.breakStart && <div className="text-red-500 text-sm mt-1">{errors.breakStart}</div>}
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label=' Break End Time'
								>
									<div className='flex justify-between'>
										<DatePicker
											format={"DD-MM-YYYY"}
											onChange={(date, dateString) =>
												handleDateTimeChange('breakEnd', 'date', dateString)
											}
											status={errors.breakEnd ? "error" : ""}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm:s"}
											onChange={(time, timeString) =>
												handleDateTimeChange('breakEnd', 'time', timeString)
											}
											status={errors.breakEnd ? "error" : ""}
										/>
									</div>
								</Form.Item> */}

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Work End Time'
									rules={[
										{
											required: true,
											message: "Please input end time!",
										},
									]}
								>
									<div className='flex justify-between'>
										<DatePicker
											format={"DD-MM-YYYY"}
											onChange={(date, dateString) =>
												handleDateTimeChange('outTime', 'date', dateString)
											}
											status={errors.outTime ? "error" : ""}
											showToday={false}
											maxDate={dayjs()}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm"}
											onChange={(time, timeString) =>
												handleDateTimeChange('outTime', 'time', timeString)
											}
											status={errors.outTime ? "error" : ""}
											showNow={false}
										/>
									</div>
									{errors.outTime && <div className="text-red-500 text-sm mt-1">{errors.outTime}</div>}
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Total Break Hours'
									name='totalBreakHours'>
									<InputNumber placeholder='Total Break Hours' />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Task'
									name='checkOutComment'>
									<Input placeholder='Task' />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									wrapperCol={{
										offset: 6,
										span: 12,
									}}>
									<Button
										onClick={() => setLoader(true)}
										type='primary'
										size='large'
										// disabled={
										// 	timeFields.inTimeDate.time === null ||
										// 	timeFields.inTimeDate.date === null
										// 	// outTimeDate.time === null ||
										// 	// outTimeDate.date === null
										// }
										htmlType='submit'
										block
										loading={loader}>
										Add Attendance
									</Button>
								</Form.Item>
							</div>
						</Form>
					</Col>
					<Col

						xs={24}
						sm={24}
						md={24}
						lg={drawer ? 20 : 10}
						xl={drawer ? 20 : 10}
						style={{ marginRight: '70px' }}
					>
						<Card
							bordered={false}
							bodyStyle={{

								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center',
								padding: '20px',
								textAlign: 'center',
							}}
							className="shadow-custom"
						>
							<Title level={4} style={{ marginBottom: '30px' }}>
								Duration Overview
							</Title>

							<Row justify="center" align="middle" style={{ width: '100%' }}>
								<Col span={24}>
									<Timeline mode="left" style={{ justifyContent: 'center', textAlign: 'center' }}>
										<Timeline.Item>
											<Typography.Text strong>Total Duration:</Typography.Text> {durations.totalDuration || "N/A"}
										</Timeline.Item>
										<Timeline.Item color="orange">
											<Typography.Text strong>Break Duration:</Typography.Text> {durations.breakDuration || "N/A"}
										</Timeline.Item>
										<Timeline.Item color="green">
											<Typography.Text strong>Worked Duration:</Typography.Text> {durations.workedDuration || "N/A"}
										</Timeline.Item>
									</Timeline>

								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</UserPrivateComponent>
			<UserPrivateComponent permission={"readAll-attendance"}>
				<GetAllAttendance />
			</UserPrivateComponent>
		</Fragment>
	);
};

export default Attendance;
